import React from "react";
import Header from "./components/Header";
import { Box } from "@chakra-ui/react";
import ProjectDetails from "./components/ProjectDetails";
import Success from "component/home/component/Success";
import Footer from "component/header/Footer";
import useScrollAnimation from "component/useScrollAnimation";

function Project() {
  useScrollAnimation();
  return (
    <Box fontFamily={"Archivo"}>
      <Header />
      <ProjectDetails />

      <Box bg="#B18E64">
        <Success />
        <Footer />
      </Box>
    </Box>
  );
}

export default Project;
